import { WritableSignal, signal } from '@angular/core';
import { TradeTemplate } from '@models/trades';
import { Project } from './project.model';

export interface ProjectContextInfo {
  id: string;
  projectName: string;
  hasAdminAccess: boolean;
  hasClientAccess: boolean;
}

export class ProjectContext {
  readonly id: string;
  readonly projectName: WritableSignal<string>;
  readonly hasAdminAccess: WritableSignal<boolean>;
  readonly hasClientAccess: WritableSignal<boolean>;
  readonly trades: WritableSignal<TradeTemplate[]> = signal<TradeTemplate[]>([]);
  readonly project: WritableSignal<Project | undefined> = signal<Project | undefined>(undefined);
  readonly mbeProjectId: WritableSignal<string | undefined> = signal<string | undefined>(undefined);

  constructor(info: ProjectContextInfo) {
    this.id = info.id;
    this.projectName = signal(info.projectName);
    this.hasAdminAccess = signal(info.hasAdminAccess);
    this.hasClientAccess = signal(info.hasClientAccess);
  }

  completeFromProject(project: Project): void {
    this.project.set(project);
    this.projectName.set(project.Name ?? this.projectName());
    this.trades.set(project.Trades ?? []);
    this.mbeProjectId.set(project.MBEProjectId);
    if (project.IsCurrentUserAdmin !== undefined) {
      this.hasAdminAccess.set(project.IsCurrentUserAdmin);
    }
    if (project.hasClientAccess !== undefined) {
      this.hasClientAccess.set(project.hasClientAccess);
    }
  }
}
